import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials so the httpOnly session_token cookie flows on protected requests
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sanctum_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
